import { formatNumber, palette, Typography } from '@dev/ee-components';
import { map } from 'lodash-es';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CampaignSummaryType } from '@/components/CampaignCreator/CampaignCreatorInterface';
import { Loader } from '../Loader';

const CampaignSummaryWrapper = styled.div`
    margin-top: 20px;
    background-color: ${palette.gray[2]};
`;
const ItemsWrapper = styled.div`
    display: grid;
    row-gap: 1px;
    & > div {
        background-color: ${palette.basic.paper};
        padding: 20px 0;
    }
`;
const CenterWrapper = styled.div`
    display: inline-flex;
    align-items: center;
`;
const Version = styled.div`
    width: 170px;
`;

export const CampaignSummary = (props: CampaignSummaryType): JSX.Element => {
    const { t } = useTranslation();
    const { data, isLoading } = props;

    const mapedSummary = (): JSX.Element[] =>
        map(data, (item) => {
            const { alphabetSignature, uniqueRecipients, uniqueRecipientsPercent, isWinner } = item;

            return (
                <CenterWrapper>
                    <Version>
                        <Typography variant="body1" bodyVariant="help">
                            {isWinner ? alphabetSignature : `${t('version')} ${alphabetSignature}`}
                        </Typography>
                    </Version>
                    <CenterWrapper>
                        <Typography variant="h4">{`${formatNumber(uniqueRecipients)} ${t(
                            'uniquerecipients'
                        )}`}</Typography>
                        <Typography
                            variant="body1"
                            bodyVariant="help"
                            style={{ marginLeft: '4px' }}
                        >{`(${uniqueRecipientsPercent}%)`}</Typography>
                    </CenterWrapper>
                </CenterWrapper>
            );
        });

    if (isLoading) {
        return <Loader />;
    }

    return (
        <CampaignSummaryWrapper>
            <ItemsWrapper>{mapedSummary()}</ItemsWrapper>
        </CampaignSummaryWrapper>
    );
};
